var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',[_c('CCardHeader',{staticClass:"bg-dark text-white"},[_vm._v(" Cloud Storage Usage ")]),_c('CCardBody',{staticClass:"bg-white"},[_c('CloudStorageChartBox')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }